import { LAYER_TYPES, useLayerType } from '~map-preview/states/layerType'

import { BoundaryAggregateInput } from './BoundaryAggregateInput'
import { BoundaryDisplayInput } from './BoundaryDisplayInput'
import { BoundaryTypeInput } from './BoundaryTypeInput'
import { HexagonAggregateInput } from './HexagonAggregateInput'
import { HexagonDisplayInput } from './HexagonDisplayInput'
import { HexagonSizeInput } from './HexagonSizeInput'
import { MarkerCategoryInput } from './MarkerCategoryInput'
import { MarkerTypeInput } from './MarkerTypeInput'

function Form() {
  const layerType = useLayerType()

  if (layerType === LAYER_TYPES.BOUNDARIES) {
    return (
      <>
        <BoundaryTypeInput />
        <BoundaryAggregateInput />
        <BoundaryDisplayInput />
      </>
    )
  }

  if (layerType === LAYER_TYPES.HEXAGON) {
    return (
      <>
        <HexagonSizeInput />
        <HexagonAggregateInput />
        <HexagonDisplayInput />
      </>
    )
  }

  if (layerType === LAYER_TYPES.MARKER) {
    return (
      <>
        <MarkerTypeInput />
        <MarkerCategoryInput />
      </>
    )
  }

  return null
}

export { Form }
